import React, { Component } from 'react'

// STYLES
import styled from 'styled-components'
import {Container} from 'react-grid-system'

// HELPERS
import {Section} from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'

export default class Join extends Component {
  render () {
    const {t, id} = this.props
    return (
      <Section id={id}>
        <Container>
          <Title color={'#2E84C6'} text={t('Como posso aderir ao Programa QUALITY')} />
          <JoinText>
            <p>{t('CP_Frase1')}</p>
            <p>{t('CP_Frase2')}</p>
            <p>{t('CP_Frase3')}</p>
          </JoinText>
        </Container>
      </Section>
    )
  }
}

const JoinText = styled.div`
    max-width: 700px;
    color: #5C5A5A;
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 23px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 767px) {
        text-align: center;
    }
`



// WEBPACK FOOTER //
// ./src/sections/join/join.component.js